module.exports = __webpack_public_path__ + "img/033.20d02599.png";